import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daytourdextinationnearmorachi() {



    const cardData =
    {
        keyword: 'Day Tour Destinations Near Morachi Chincholi Pune',
        heading: 'Anand Krushi Paryatan Kendra: Day Tour Destinations Near Morachi Chincholi Pune',
        headingDescription: 'Looking for peaceful and fun-filled day tour destinations near Morachi Chincholi Pune? Anand Krushi Paryatan Kendra is a top pick for a one-day rural getaway just 55 km from Pune. Spread across 40 acres of green farmland, this agri-tourism center offers a refreshing escape into nature with a perfect mix of traditional village life and modern leisure. Whether you’re planning a family outing, school trip, or corporate tour, this destination has something for everyone—bullock cart and tractor rides, horse riding, swimming, boating, rain dance, and traditional village games. Guests are also entertained with puppet shows, magic shows, and adventurous activities throughout the day.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Morachi Chincholi – Agro Tourism Village",
    "description": "Famous for its natural peacock population and rural charm, this village offers tractor rides, bullock carts, organic farming, folk performances, and delicious Maharashtrian food. A perfect family-friendly one-day escape from Pune."
  },
  {
    "title": "Ranjangaon Mahaganpati Temple",
    "description": "Located just 25 km from Morachi Chincholi, this is one of the eight revered Ashtavinayak temples dedicated to Lord Ganesha. Known for its grand architecture and spiritual atmosphere, it makes for a peaceful spiritual stop."
  },
  {
    "title": "Shivneri Fort",
    "description": "About 60 km from Morachi Chincholi, this historic hill fort is the birthplace of Chhatrapati Shivaji Maharaj. Ideal for history lovers and trekking enthusiasts. The fort offers scenic views and a deep dive into Maratha heritage."
  },
  {
    "title": "Tulapur – Historic Riverside Village",
    "description": "A small but historically significant site where Sambhaji Maharaj was martyred. Located on the banks of Bhima River, it’s a quiet spot for history buffs and offers riverside serenity."
  },
  {
    "title": "Bhuleshwar Temple",
    "description": "An ancient Shiva temple located about 50 km from Morachi Chincholi, known for its unique architecture blending Hindu and Islamic styles. The temple sits atop a hill and provides a scenic drive and spiritual atmosphere."
  },
  {
    "title": "Pawna Lake Viewpoint (Extended Day Trip)",
    "description": "Although around 90 km away, this spot is perfect if you're combining a rural retreat with a lakeside picnic. Great for couples or groups looking to unwind with nature, especially during winter or monsoon."
  },
  {
    "title": "Ghod River Dam Backwaters (Local Picnic Spot)",
    "description": "Located around 10–12 km from Morachi Chincholi, this peaceful backwater area is perfect for quick relaxation, birdwatching, and riverside photography."
  },
  {
    "title": "Chintamani Ganpati Temple, Theur",
    "description": "About 65 km away, Theur is another of the Ashtavinayak pilgrimage sites and offers a blend of devotion, architecture, and local food culture. Can be clubbed with Morachi Chincholi for a full spiritual-rural day."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary (Long Day Trip)",
    "description": "If you're up for a long drive (approx. 100 km), Bhimashankar is ideal for trekking, jungle walks, and visiting the Jyotirlinga temple. Best suited for nature and adventure lovers."
  }
],




"services": [
  {
    "name": "Popular Day Tour Places Near Morachi Chincholi",
    "description": "Explore top-rated day tour destinations near Morachi Chincholi, including Anand Krushi Paryatan Kendra—a serene agro-tourism hub offering immersive farm activities, nature walks, traditional food, and family-friendly fun all in one peaceful rural escape."
  },
  {
    "name": "Nature-Centric Day Trips",
    "description": "Reconnect with nature at Anand Krushi Paryatan Kendra through guided farm trails, orchard walks, and eco-education experiences. Ideal for day trippers looking to escape the city and breathe fresh countryside air surrounded by greenery and wildlife."
  },
  {
    "name": "Historical Forts and Landmarks",
    "description": "Combine your visit with a short trip to nearby forts like Shivneri or ancient temples in the region. Anand Krushi Paryatan Kendra also celebrates rural heritage through traditional games, cultural storytelling, and farming history exhibits."
  },
  {
    "name": "Wildlife Parks and Sanctuaries",
    "description": "Located in the natural habitat of peacocks, the farm is a gateway to local wildlife experiences. Birdwatchers and animal lovers can explore nearby forest patches or enjoy morning tours to spot native species right on the farm."
  },
  {
    "name": "Scenic Hill Stations",
    "description": "Plan a refreshing combo day with a trip to nearby hillocks or forested plateaus and relax afterward at Anand Krushi Paryatan Kendra with a hearty farm lunch, nature trails, and peaceful rural vibes to complete your day."
  },
  {
    "name": "Adventure Activity Spots",
    "description": "Anand Krushi Paryatan Kendra adds a touch of adventure to your day trip with rope walks, tire challenges, bullock cart rides, and traditional rural games—fun for kids, teens, and adults alike in a natural, open setting."
  },
  {
    "name": "Waterfall Day Trips",
    "description": "During monsoon season, explore seasonal waterfalls near Morachi Chincholi, and pair your visit with a meal and nature experience at Anand Krushi Paryatan Kendra for a perfect rainy-day outing."
  },
  {
    "name": "Cultural Tour Destinations",
    "description": "Enjoy rural life through folk dance performances, local music, and hands-on farming experiences. Anand Krushi Paryatan Kendra gives visitors a glimpse into traditional Maharashtrian culture through food, art, and storytelling."
  },
  {
    "name": "Family-Friendly Day Tours",
    "description": "This farm offers a full day of engaging activities for all age groups—nature walks, play zones, petting farm animals, and cultural shows—making it one of the best family day tour spots near Morachi Chincholi."
  },
  {
    "name": "Picnic and Relaxation Spots",
    "description": "Pack a picnic or enjoy a farm-fresh meal under shady trees or in traditional gazebos. Anand Krushi Paryatan Kendra features clean picnic areas perfect for relaxed family outings, school groups, or quiet solo escapes."
  },
  {
    "name": "Bird Watching Locations",
    "description": "Home to hundreds of peacocks and local birds, the farm is a prime location for birdwatching. Bring your binoculars and capture the sights and sounds of rural avian life while exploring the natural trails."
  },
  {
    "name": "Eco-Tourism Day Trips",
    "description": "Explore eco-conscious farming, organic techniques, and sustainability practices on a guided day tour at the farm. Anand Krushi Paryatan Kendra is an ideal destination for environmentally mindful visitors."
  },
  {
    "name": "Heritage Villages",
    "description": "Step into a living heritage village experience through rural games, cooking demos, and traditional farming techniques. Anand Krushi Paryatan Kendra celebrates age-old rural lifestyles and offers immersive heritage-style tourism."
  },
  {
    "name": "Local Craft and Market Tours",
    "description": "Tour local markets and buy farm-fresh produce, handmade pickles, and regional crafts. The farm’s in-house stall lets visitors take home a slice of the rural experience with authentic goods made on-site."
  },
  {
    "name": "Wellness Day Trips",
    "description": "Enjoy peaceful moments with yoga, nature meditation, and mindful walks through green trails. Anand Krushi Paryatan Kendra offers a calm setting perfect for mental reset and physical rejuvenation amid rural nature."
  }
],
"tableData": [
  ["Popular Day Tour Places Near Morachi Chincholi", "- Nature-Centric Day Trips"],
  ["Historical Forts and Landmarks", "- Wildlife Parks and Sanctuaries"],
  ["Scenic Hill Stations", "- Adventure Activity Spots"],
  ["Waterfall Day Trips", "- Cultural Tour Destinations"],
  ["Family-Friendly Day Tours", "- Picnic and Relaxation Spots"],
  ["Bird Watching Locations", "- Eco-Tourism Day Trips"],
  ["Heritage Villages", "- Local Craft and Market Tours"],
  ["Wellness Day Trips", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Nighoj Potholes & Kukadi River Gorge",
    "WhyChoosedescription": "Located about 25 km from Morachi Chincholi, Nighoj features rare natural potholes formed by the Kukadi River. It's a fascinating geological site and perfect for nature photography and exploration."
  },
  {
    "WhyChooseheading": "Ranjangaon Mahaganpati Temple",
    "WhyChoosedescription": "One of the eight revered Ashtavinayak temples, this beautifully crafted Ganpati temple is just 40–45 km away. It’s a spiritually significant and peaceful destination, ideal for a short visit."
  },
  {
    "WhyChooseheading": "Shirur Fort",
    "WhyChoosedescription": "Situated around 20 km from Morachi Chincholi, Shirur Fort offers a quiet historical escape with sweeping views of the surrounding region—great for a half-day outing."
  },
  {
    "WhyChooseheading": "Bhuleshwar Temple",
    "WhyChoosedescription": "Approximately 50 km from Morachi Chincholi, this ancient Shiva temple sits atop a hill and features exquisite carvings. A calm, spiritual site that combines history, architecture, and panoramic views."
  },
  {
    "WhyChooseheading": "Vadgaon Dam",
    "WhyChoosedescription": "A calm and green spot ideal for picnics and nature walks, Vadgaon Dam is close to Shirur and provides a cool retreat for families and small groups."
  },
  {
    "WhyChooseheading": "Anand Krushi Paryatan Kendra",
    "WhyChoosedescription": "Located in Morachi Chincholi itself, this agro-tourism center offers everything from farm activities and peacock watching to delicious Maharashtrian meals and adventure sports—ideal for a full-day family experience."
  },
  {
    "WhyChooseheading": "Loni Kalbhor",
    "WhyChoosedescription": "Located 40 km away, this village destination provides a glimpse into rural Maharashtrian culture and is known for its scenic drives and traditional eateries."
  },
  {
    "WhyChooseheading": "Ramling Temple",
    "WhyChoosedescription": "This tranquil temple dedicated to Lord Shiva is located about 30 km away. Surrounded by greenery, it offers a spiritual stop amidst nature for a calm and reflective break."
  }
]












    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'What are some ideal day tour destinations near Morachi Chincholi?',
    answer: 'You can visit Ranjangaon Mahaganpati Temple, Alandi Temple, Anand Krushi Paryatan Kendra, Shikrapur sugar mills (educational), and Jejuri Khandoba Temple—all within 30–60 km.',
  },
  {
    id: 'FAQ2',
    question: 'Can these locations be visited in a single day?',
    answer: 'Yes, with an early start, you can comfortably cover 2–3 attractions in a single day, including Morachi Chincholi itself.',
  },
  {
    id: 'FAQ3',
    question: 'How far is Ranjangaon Ganpati from Morachi Chincholi?',
    answer: 'Ranjangaon, part of the Ashtavinayak circuit, is around 25 km (approx. 30–40 min by road) from Morachi Chincholi.',
  },
  {
    id: 'FAQ4',
    question: 'What can I do at Anand Krushi Paryatan Kendra during a day tour?',
    answer: 'Enjoy pony and tractor rides, butterfly watching, farm walks, rural games, and traditional meals—all ideal for a peaceful countryside experience.',
  },
  {
    id: 'FAQ5',
    question: 'Is Alandi worth including in a day tour?',
    answer: 'Yes, especially for spiritual seekers. Alandi is home to the Samadhi of Saint Dnyaneshwar and is a serene pilgrimage destination.',
  },
  {
    id: 'FAQ6',
    question: 'Are there any nature-based stops along the way?',
    answer: 'Yes. Morachi Chincholi itself is known for peacock sightings and rural nature trails. You can also explore riverbanks and farmlands nearby.',
  },
  {
    id: 'FAQ7',
    question: 'Are meals and rest areas available at these locations?',
    answer: 'Yes. Agro-tourism centers like Anand Krushi and temples like Ranjangaon and Alandi have food stalls or nearby local restaurants.',
  },
  {
    id: 'FAQ8',
    question: 'Is this route suitable for school or educational day tours?',
    answer: 'Definitely. It offers learning on farming, rural life, nature, and heritage—all packed into a well-paced educational tour.',
  },
  {
    id: 'FAQ9',
    question: 'What is the best time to plan a day tour?',
    answer: 'Monsoon to early winter (June to November) is ideal due to greenery, cool weather, and active peacock sightings.',
  },
  {
    id: 'FAQ10',
    question: 'Should I book tours or guides in advance?',
    answer: 'For agro-tourism or large groups, it’s best to pre-book for meals, rides, and educational walkthroughs. Temples don’t require advance booking.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Neeta Salunkhe, Pune',
    feedback: "Our day tour from Pune included Morachi Chincholi, Anand Krushi, and Ranjangaon. It was peaceful, educational, and fun for the whole family!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Ravi Menon, School Coordinator',
    feedback: "We took 40 students on a one-day tour including the peacock sanctuary and an agro-tourism farm. The kids had a blast, and the learning was hands-on and impactful.",
    rating: 5,
  },
];













    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Day Tour Destinations Near Morachi Chincholi Pune",
  "image": "https://morachichincholi.in/assets/images/day-tour-destinations-morachi-chincholi.jpg",
  "description": "Explore popular day tour destinations near Morachi Chincholi Pune. From scenic hill stations and waterfalls to heritage villages, wildlife parks, and cultural hotspots – enjoy nature, history, and wellness all in one trip.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2263"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "600",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/day-tour-destinations-morachi-chincholi"
  }
};



    return (
        <div>
<Helmet>
  <title>Day Tour Destinations Near Morachi Chincholi Pune | Nature, Culture & Family Fun | Anand Krushi Paryatan Kendra</title>
  <meta 
    name="description" 
    content="Discover day tour destinations near Morachi Chincholi Pune. Perfect for families, couples, and groups—explore waterfalls, wildlife sanctuaries, historical forts, and eco-tourism spots with Anand Krushi Paryatan Kendra." 
  />
  <meta 
    name="keywords" 
    content="Popular day tour places near Morachi Chincholi, Nature-centric day trips, Historical forts and landmarks, Wildlife parks and sanctuaries, Scenic hill stations, Adventure activity spots, Waterfall day trips, Cultural tour destinations, Family-friendly day tours, Picnic and relaxation spots, Bird watching locations, Eco-tourism day trips, Heritage villages, Local craft and market tours, Wellness day trips" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/13.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Daytourdextinationnearmorachi;